import React from "react";
import styles from "./index.module.scss";
import { Sidebar } from "primereact/sidebar";
import FiltersComponent from "../filters-component";

interface propsType {
  showFilter: boolean;
  setShowFilter: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function FilterModelMobile({ showFilter, setShowFilter }: propsType) {
  return (
    <Sidebar
      visible={showFilter}
      position="top"
      onHide={() => setShowFilter(false)}
      className={styles.FilterModel}
    >
      <FiltersComponent setShowFilter={setShowFilter} />
    </Sidebar>
  );
}
